export default __webpack_public_path__ + "static/media/headUltrasonic.4183442a.svg";